import { useMessage } from "@hermes/intl";
import { useChildrenAgeOptions } from "@hermes/shared";
import {
  createStaticStyles,
  type Field,
  FilterOutlinedButton,
  Select,
  type SelectState,
  ToggleSwitch,
  type ToggleSwitchState,
} from "@hermes/ui";

import { containerBorderBlockEndStyles } from "../quick-modal";

const childShortStyles = createStaticStyles.clean({
  display: "grid",
  gridTemplateColumns: "1fr",
  rowGap: 10,
  paddingBlockEnd: 16,
});

export const ChildShort = ({
  childField,
  childAgeField,
}: {
  childField: Field<ToggleSwitchState>;
  childAgeField: Field<SelectState<number>>;
}) => {
  const message = useMessage();
  const options = useChildrenAgeOptions();

  const selectedOption = options.find(
    (option) => option.value === childAgeField.value,
  );

  const props = {
    text:
      selectedOption?.label ??
      message({ id: "e509736b-e018-4da6-8dd5-c3fadbce0956" }),
    active: childAgeField.value !== null,
    onClear: () => {
      childAgeField.onChange({ value: null });
    },
    clearable: true,
  };

  return (
    <div css={[childShortStyles, containerBorderBlockEndStyles]}>
      <ToggleSwitch
        field={childField}
        label={message({
          id: "doctors-list.filters.children",
        })}
        onChange={(value) => {
          if (!value) childAgeField.onChange({ value: null });
        }}
      />
      {childField.value && (
        <Select
          field={childAgeField}
          options={options}
          mobile={{
            title: message({
              id: "e509736b-e018-4da6-8dd5-c3fadbce0956",
            }),
          }}
        >
          {({ triggerRef, triggerProps }) => (
            <FilterOutlinedButton.EmphasizedDropdown
              triggerRef={triggerRef}
              triggerProps={triggerProps}
              {...props}
            />
          )}
        </Select>
      )}
    </div>
  );
};
